import {InjectionToken} from '@angular/core';

export const BP_CONFIG = new InjectionToken('mydocma-bp-config');


export interface BpConfig {
  "apiUrl": string;
  "production": boolean;
  "buildTarget"?:string;
  "appName": string;
  "appIconColor": string;
  "mydocmaConfig": {
    "apiUrl": string;
    "clientUrl": string;
    "appId": string;
  };
  "authConfig": {
    "clientId": string;
    "scope": string;
    "oidc": boolean;
    "issuer": string;
    "redirectUri": string;
    "requireHttps": boolean;
    "responseType": string;
    "ignoredUrls": Array<string>;
    "logoutUrl": string;
    "postLogoutRedirectUri": string;
  };

  "bpConfig": {
    "apiUrl": string; //"https://api-test.edr-software.com/reppix/2.8"
  }
  "webSocketConfig": {
      "serverUrl": string;
      "reconnectInterval": number;
      "reconnectAttempts": number;
      "heartbeatInterval": number;
  };
  "taskConfig": {
      "apiUrl": string;
  };
  "appContainerConfig": {
    "showBackdropOnCustomerChange": boolean;
  }
}
